import Showtimes2 from 'components/bolt/showtimes/showtimes2';

export default Showtimes2;